export const heroBanner =
  "https://barewitness.com/wp-content/uploads/2012/07/cropped-Liz-Amongst-the-Art_header1.jpg";

export const clapperPhoto =
  "https://barewitness.com/wp-content/uploads/2015/07/P7110231web.jpg";

export const brandLogo =
  "https://barewitness.com/wp-content/uploads/2012/10/BWlogo_paypal_v6.jpg";

export const socialLinks = [
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/barewitnessfilms", icon: "ri-facebook-fill" },
  { id: "youtube", label: "YouTube", href: "http://www.youtube.com/user/barewitnessfilms", icon: "ri-youtube-fill" },
];

export const navLinks = [
  { id: "home", label: "Home", href: "#home" },
  { id: "about", label: "About", href: "#about" },
  { id: "films", label: "Films", href: "#films" },
  { id: "players", label: "Players", href: "#players" },
  { id: "news", label: "News", href: "#news" },
  { id: "contact", label: "Contact", href: "#contact" },
];

export const studioStats = [
  { id: "films", value: "24", label: "Films Shaped" },
  { id: "festivals", value: "18", label: "Festival Selections" },
  { id: "years", value: "12", label: "Years Making Movies" },
  { id: "players", value: "11", label: "Core Players" },
];

export const films = [
  {
    id: "buddy",
    title: "Buddy",
    year: "2019",
    format: "Short Film",
    runtime: "14 min",
    badge: "Four Nominations",
    logline:
      "A quiet, wry look at loyalty and the small choices that quietly define a friendship.",
  },
  {
    id: "and-were-back",
    title: "And We’re Back!",
    year: "2019",
    format: "Short Film",
    runtime: "12 min",
    badge: "New Release",
    logline:
      "The collective returns with a warm story about starting over in the Bay Area.",
  },
  {
    id: "return-to-downieville",
    title: "Return to Downieville",
    year: "2018",
    format: "Short Film",
    runtime: "11 min",
    badge: "Official Selection",
    logline:
      "A road trip back to a gold-rush town unearths more than the travellers bargained for.",
  },
  {
    id: "stan-is-the-best-director",
    title: "Stan is the Best Director",
    year: "2018",
    format: "Behind the Scenes",
    runtime: "8 min",
    badge: "Festival Premiere",
    logline:
      "A loving, wry portrait of the collective at work, told from the director’s chair.",
  },
  {
    id: "48-hour-film-sf",
    title: "48 Hour Film SF",
    year: "2017",
    format: "Festival Entry",
    runtime: "7 min",
    badge: "Audience Favorite",
    logline:
      "Written, shot, and cut in a single weekend for the 48 Hour Film Project.",
  },
  {
    id: "upon-the-stage",
    title: "Upon the Stage",
    year: "2017",
    format: "Documentary Short",
    runtime: "16 min",
    badge: "Official Selection",
    logline:
      "Following the players from the rehearsal room out into the lights.",
  },
];

export const players = [
  { id: "stan-stone", name: "Stan Stone", role: "Director" },
  { id: "glenda-solis", name: "Glenda Solis", role: "Writer" },
  { id: "robin-mcleod", name: "Robin McLeod", role: "Actor" },
  { id: "jan-probst", name: "Jan Probst", role: "Cinematographer" },
  { id: "anna-elder", name: "Anna Elder", role: "Producer" },
  { id: "alex-alexander", name: "Alex Alexander", role: "Editor" },
  { id: "kerry-gudjohnsen", name: "Kerry Gudjohnsen", role: "Actor" },
  { id: "marie-bouquet-hay", name: "Marie Bouquet Hay", role: "Actor" },
  { id: "mark-rachel", name: "Mark Rachel", role: "Sound" },
  { id: "matthew-gardner", name: "Matthew Gardner", role: "Composer" },
  { id: "sue-jereczek", name: "Sue Jereczek", role: "Production Design" },
];

export const newsItems = [
  {
    id: "and-were-back",
    title: "And We’re Back!",
    date: "August 2019",
    category: "Announcement",
    excerpt:
      "After a short hiatus, the collective is back in front of the camera and behind the edit.",
  },
  {
    id: "four-nominations-for-buddy",
    title: "Four Nominations for Buddy!",
    date: "June 2019",
    category: "Festival News",
    excerpt:
      "Our short film Buddy picked up four nominations across directing, writing, and ensemble.",
  },
  {
    id: "return-to-downieville",
    title: "Return to Downieville",
    date: "May 2018",
    category: "Release",
    excerpt:
      "A new short about going back — shot on location in the Sierra foothills.",
  },
  {
    id: "stan-is-the-best-director",
    title: "Stan is the Best Director",
    date: "March 2018",
    category: "Behind the Scenes",
    excerpt:
      "A peek inside the process, and a tribute to the person who keeps the take going.",
  },
  {
    id: "48-hour-film-sf-again",
    title: "48 Hour Film SF (Again!)",
    date: "September 2017",
    category: "Festival",
    excerpt:
      "One weekend, one genre, one rule: finish the film. Here’s how it went.",
  },
];